<template>
  <div
    class="bg-white rounded-full border border-black/5 flex items-center justify-center mb-2 badge--shadow"
  >
    <DacrIcon :class="{ 'size-full': !iconSize }" :style="iconStyles" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { DacrIcon } from '@dacr/icons'

const props = defineProps<{
  iconSize?: number
}>()

const iconStyles = computed(() =>
  props.iconSize
    ? { width: `${props.iconSize}px`, height: `${props.iconSize}px` }
    : undefined
)
</script>

<style scoped>
.badge--shadow {
  box-shadow: 0 4px 18px 0px rgba(0, 0, 0, 0.04);
}
</style>
